import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { ShippingAdminController, StorefrontShippingController } from './shipping.controller';
import { ShippingService } from './shipping.service';

@Module({
  controllers: [ShippingAdminController, StorefrontShippingController],
  providers: [PrismaService, ShippingService],
  // Exported so CheckoutService prices through the same path the storefront
  // quoted from — two pricing paths would eventually disagree, and the shopper
  // would be charged the one they were not shown.
  exports: [ShippingService],
})
export class ShippingModule {}
